<template>
  <!-- 规划师沟通提醒 -->
  <div class="communicateDia">
    <div class="popup" style="background: #fff; ">
      <p class=" popup_top" style="text-align: left; margin-top: 15px;"><i class="el-icon-warning"
          style="color: #0e99db; margin-right: 5px;"></i><span style="margin-right: 10px;">规划师沟通提醒</span> </p>
      <el-form class="demo-form-inline" label-width="100px">
        <el-form-item label="沟通时间:">
          <el-date-picker type="date" placeholder="选择日期" clearable v-model="paging.thisTime" style="width: 100%;"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="学生姓名:">
          <el-select v-model="paging.studentId" clearable filterable placeholder="请选择">
            <el-option v-for="item in studentArr" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规划师姓名:">
          <el-select v-model="paging.teacherId" clearable filterable placeholder="请选择">
            <el-option v-for="item in teacherArr" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="沟通方式:">
          <el-input v-model="paging.commType" clearable placeholder="请输入内容"></el-input>
        </el-form-item> -->
        <el-form-item label="沟通情况:">
          <el-select v-model="paging.commStatus" filterable clearable placeholder="请选择">
            <el-option v-for="item in commStatusOp" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售完成情况:">
          <el-select v-model="paging.isOver" filterable clearable placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchBtn" size="small" class="btns" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" @click="clearBtn" class="btns" size="small" icon="el-icon-close">清除</el-button>
          <el-button type="primary" @click="addcommunicate" size="small" class="btns" icon="el-icon-plus">添加</el-button>
        </el-form-item>
        <el-form-item>
          <!-- <el-button type="primary">规划师沟通记录</el-button> -->
        </el-form-item>
      </el-form>
      <el-table :data="tableData" stripe height="500" style="width: 99%; margin:20px auto; " border :header-cell-style="{
        background: '#fafafa',
        'text-align': 'center'
      }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column prop="studentName" label="学生姓名">
        </el-table-column>
        <el-table-column prop="teacherName" label="规划师姓名">
        </el-table-column>
        <el-table-column prop="thisTime" label="沟通日期">
        </el-table-column>
        <el-table-column prop="startTime" label="沟通时间">
        </el-table-column>
        <el-table-column prop="commType" label="沟通方式">
        </el-table-column>
        <el-table-column label="沟通情况">
          <template slot-scope="scope">
            <!-- <el-radio-group v-model="scope.row.commStatus">
              <el-radio :label="1">已沟通</el-radio>
              <el-radio :label="0">未沟通</el-radio>
            </el-radio-group> -->
            <span v-if="scope.row.commStatus == 1">已沟通</span>
            <span v-if="scope.row.commStatus == 0">未沟通</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="沟通结果反馈">
          <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row.id)">详情</el-button>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="commRemark" label="沟通结果反馈">
        </el-table-column> -->
        <el-table-column label="销售完成情况" width="250px">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.isOver" @change="changeStatus(scope.row)">
              <el-radio :label="1">已完成</el-radio>
              <el-radio :label="0">未完成</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>

        <el-table-column fixed="right" prop="address" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
            <el-button type="text" @click="editbtn(scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="paging.pageNum"
        :page-size="paging.pageSize" layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="flog ? '添加' : '编辑'" :visible.sync="dialogVisible" width="50%">
      <el-form :model="dialogObj" label-width="120px">
        <el-form-item label="学生姓名">
          <el-select placeholder="请选择学生姓名(可搜索)" clearable filterable v-model="dialogObj.studentId" style="width:100%;">
            <el-option v-for="item in studentArr" :key="item.id" :value="item.id" :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规划师姓名">
          <el-select placeholder="请选择规划师(可搜索)" clearable filterable v-model="dialogObj.teacherId" style="width:100%;">
            <el-option v-for="item in teacherArr" :key="item.id" :value="item.id" :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="沟通日期:" prop="thisTime">
          <el-date-picker type="date" v-model="dialogObj.thisTime" placeholder="选择日期" style="width: 100%;"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开始时间:" prop="startTime">
          <mz-time-select @clena="clean" :timePeriod="'start'" @startTimeSelect="startTimeSelect"
            :childPlaceholder="'开始时间'" v-model="dialogObj.startTime" :valueTime="dialogObj.startTime"></mz-time-select>
        </el-form-item>
        <el-form-item label="结束时间:" prop="endTime">
          <mz-time-select @clean="clean" :timePeriod="'end'" :childPlaceholder="'结束时间'" @startTimeSelect="startTimeSelect"
            v-model="dialogObj.endTime" :valueTime="dialogObj.endTime"></mz-time-select>
        </el-form-item>
        <el-form-item label="沟通方式:">
          <el-input clearable v-model="dialogObj.commType" placeholder="请输入沟通方式"></el-input>
        </el-form-item>
        <el-form-item label="目的:">
          <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="dialogObj.comFinal"
            placeholder="请输入目的"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Save">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog title="详情" :visible.sync="detailDia" width="50%">
      <el-form label-width="100px">
        <el-form-item label="沟通结果反馈">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" placeholder="请输入内容" v-model="content">
          </el-input>
        </el-form-item>
        <el-form-item label="相关资料" style="text-align: left;">
          <ul style="list-style-type: none;">
            <li v-for="(item, index) in fileList" :key="index"><a :href="item.url" download="file">{{
              item.name }}</a></li>
          </ul>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDia = false">取 消</el-button>
        <el-button type="primary" @click="detailDia = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="沟通详情" :visible.sync="detailFlog" width="50%">
      <el-form label-width="100px">
        <el-form-item label="沟通详情">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" v-model="commRemark">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailFlog = false">取 消</el-button>
        <el-button type="primary" @click="detailFlog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPlanComm, getTeachers, getStudents, addItem, changeSta, editItem, editSave, getdeta } from "@/api/communicateApi"
export default {
  data () {
    return {
      detailFlog: false,
      commRemark: '',
      detailDia: false,
      content: '',
      fileList: [],
      flog: true,//判断是添加还是编辑
      dialogVisible: false,//控制弹窗显示隐藏
      dialogObj: {
        comFinal: '',
        studentId: '',//学生id
        teacherId: '',//规划师id
        thisTime: '',//沟通时间
        commType: '',//沟通方式
        startTime: '',
        endTime: ''
      },
      commStatusOp: [{ value: '1', label: '已沟通' }, { value: '0', label: "未沟通" }],
      options: [{ value: '1', label: "已完成" }, { value: '0', label: '未完成' }],
      teacherArr: [],//所有老师
      studentArr: [],//所有学生
      total: 0,//总条数
      paging: {//分页
        commStatus: "",
        // commType: '',//沟通方式
        pageNum: 1,
        pageSize: 10,
        studentId: "",//学生
        teacherId: '',//规划师
        thisTime: '',//沟通花时间
        isOver: '',//销售完成情况
      },
      tableData: [],//table表格数据
    }
  },
  created () {
    this.getList();
    this.getTeacher()
    this.getStudent()
  },
  methods: {
    //详情
    detail (id) {
      this.detailDia = true
      getdeta(id).then(res => {
        this.content = res.data.content
        this.fileList = res.data.urlList
      })
    },
    clean (val) {
      if (val == "start") {
        this.diagnosisOff.startTimeHour = ''
      } else {
        this.diagnosisOff.endTimeHour = ''
      }
    },
    startTimeSelect (val, row) {
      if (val == "start") {
        this.dialogObj.startTime = row
      } else {
        this.dialogObj.endTime = row
      }
    },
    //获取所有老师
    getTeacher () {
      getTeachers().then(res => {
        this.teacherArr = res.data
      })
    },
    //获取所有学生
    getStudent () {
      getStudents().then(res => {
        this.studentArr = res.data
      })
    },
    //获取table数据
    getList () {
      getPlanComm(this.paging).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    //添加按钮
    addcommunicate () {
      this.dialogVisible = true
      this.flog = true
      this.dialogObj = {}
    },
    //清除按钮
    clearBtn () {
      this.paging.commStatus = ""
      this.paging.pageNum = 1
      this.paging.studentId = ""
      this.paging.teacherId = ""
      this.paging.thisTime = ""
      this.paging.isOver = ""
      this.getList()
    },
    //修改销售完成情况状态isOver
    changeStatus (row) {
      if(row.commStatus == 0){
         this.$message({message: '沟通情况必须为已沟通',type: 'warning' });
         row.isOver = 0
      }else{
        let type = row.isOver
        this.$confirm('此操作将修改销售完成情况, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            changeSta(row).then(res => {
              if (res.code == 200) {
                this.$message.success(res.message)
              } else {
                this.$message.error(res.message)
              }
              this.getList()
            })
          }).catch(() => {
            row.isOver = type == 1 ? 0 : 1
            this.$message({
              type: 'warning',
              message: '已取消'
            });
          });
      }
    },
    //编辑回显
    edit (id) {
      this.flog = false
      this.dialogVisible = true
      editItem(id).then(res => {
        this.dialogObj = res.data
      })
    },
    editbtn (id) {
      this.detailFlog = true
      editItem(id).then(res => {
        this.commRemark = res.data.commRemark
      })
    },
    //添加编辑保存
    Save () {
      if (this.flog) {
        //添加保存
        addItem(this.dialogObj).then(res => {
          if (res.code == 200) {
            this.$message.success(res.message)

          } else {
            this.$message.error(res.message)
          }
          this.getList()
        })
        this.dialogVisible = false
      } else {
        //编辑保存
        editSave(this.dialogObj).then(res => {
          if (res.code == 200) {
            this.$message.success(res.message)

          } else {
            this.$message.error(res.message)
          }
          this.getList()
        })
        this.dialogVisible = false
      }
    },
    //搜索按钮
    searchBtn () {
      this.paging.pageNum = 1
      this.getList();
    },
    //分页
    handleSizeChange () {

    },
    handleCurrentChange (v) {
      this.paging.pageNum = v;
      this.getList();
    },
  }
}
</script>

<style scope>
header {
  text-align: left;
}

.pending {
  text-align: left;
}

.pending p {
  font-size: 14px;
}

.pending_bottom {
  width: 100%;
  height: 140px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 10px;
}

.pending_item {
  width: 170px;
  height: 100px;
  border-radius: 10px;
}

.pending_item p {
  margin-top: 20px;
  margin-left: 25px;
}

.leave {
  background: linear-gradient(to right, #028bcf, #80d0f6);
}

.renew {
  background: linear-gradient(to right, #fdbe29, #fecf64);
}

.communication {
  background: linear-gradient(to right, #5d9656, #aac8a6);
}

.afterClass {
  background: linear-gradient(to right, #ff698a, #fe9f74);
}

.first {
  background: linear-gradient(to right, #d87ea3, #e3c5c6);
}

.classroom {
  background: linear-gradient(to right, #1da8aa, #94e0dd);
}

.issue {
  background: linear-gradient(to right, #f4ab56, #f6cd9e);
}

.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.demo-form-inline .el-form-item {
  margin-right: 30px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .fiveLessons {
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.fiveLessons {
    width: 70% !important;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/afterSales/communicate.vue